import React from 'react';
import { Container, Paper, Typography } from '@material-ui/core';
import useStyles from '../../common/styles';
import BarChart from 'components/@common/Charts/BarChart';
import { buildOptions, buildSeries } from '../util';
import { PrmStudentEngagementReportResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';

type Props = {
  prmStudentEngagementReport: PrmStudentEngagementReportResult;
};
const Engagement: React.FC<Props> = ({ prmStudentEngagementReport }) => {
  const classes = useStyles();

  const [, setQuery] = useReportQueryParams();
  const handleChartClick = (index: number): void => {
    const ids = prmStudentEngagementReport.studentCurriculumProgress.flatMap(
      progress => progress.studentId
    );
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: ids[index] }, 'pushIn');
  };

  return (
    <>
      <Typography variant="h3" style={{ marginBottom: 6, fontWeight: 450 }}>
        Engagement
      </Typography>
      <Paper className={classes.container} style={{ justifyContent: 'flex-start' }}>
        <Container>
          <BarChart
            type="bar"
            series={buildSeries(prmStudentEngagementReport)}
            options={buildOptions(prmStudentEngagementReport)}
            onClick={handleChartClick}
          />
        </Container>
      </Paper>
    </>
  );
};

export default Engagement;
